import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { FormGroup, Slider, InputGroup, Button,HTMLSelect, H4, Tab, Tabs } from '@blueprintjs/core';
import MaterialTable from 'material-table';
import { TablePagination } from '@material-ui/core';
import { prepDangerouslySetInnerHTMLString, specialSlice } from '../concord/utils';

class ClusterMlm extends React.PureComponent {

  state = {
    tokenId:"#1",
    nbClust:0,
    minCos:80,
    minClustSize:1,
  }

  onTokenIdChange = (e) => {
    e.preventDefault();
    this.setState({ tokenId: e.target.value });
  }

  // first arg is the rowData
  openContextWindow = (e) => {
    e.preventDefault();
    
    if (! e.currentTarget.value) { // use e.currentTarget instead of e.target
        return;
    }

    const concordData=this.props.sentId2Concord[e.currentTarget.value];
    if (! concordData) {
        console.log("concordData vide");
        return;
    }  
    const { results } = this.props;
    
    const docMeta=results.concord.docMeta;
    const lang=results.lang;
    const aligned_language=results.aligned_language;

    const data = {
      sent_id: concordData.sentId,
      collection: docMeta[concordData.docId].collection,
      lang: lang,
      aligned_language:aligned_language
    };

    const endpoint = '/get_result_meta.ajax.php';
    fetch(
      process.env.REACT_APP_API_BASE + endpoint, {
        credentials: process.env.REACT_APP_CREDENTIALS,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      .then((res) => {
        if (res.status !== 200) {
          console.log(`Issue reaching ${endpoint}`);
          return;
        }
        res.json().then((concordDetail) => {
          window.open(concordDetail.permalink,'_blank')
        })
      })
      .catch(() => {
        console.log(`Network error when trying to fetch ${endpoint}`);
      })
     
  };

  
  render() {
      const { t, results } = this.props;
      const labels=results["labels"];
      const clusters=results["clusters"];
      const { tokenId, nbClust, minCos } =this.state;
      const span=60;
      const tableDataByConcord=[];
      const tableDataByPivot=[];



      //console.log(tokenId,nbClust);
      //console.log(clusters);
      //console.log(labels);

      // The key may be computed according to nbClust or minCos
      const key=(minCos===0)? nbClust:minCos;

      // By concord
      const byConcord=clusters["byConcord"][tokenId] && clusters["byConcord"][tokenId][key];
      if (byConcord) {
  
        const clustIdSize={};
        // first the size of the clusters are computed, in order to filter by size
        for (var i in clusters["byConcord"][tokenId][key]) {
          const clustId=clusters["byConcord"][tokenId][key][i];
          if (clustIdSize[clustId]===undefined) {
            clustIdSize[clustId]=0;
          }
          clustIdSize[clustId]+=1;
        }
        const clustNum={};
        var num=0;
        for (var clustId of Object.keys(clustIdSize).sort((a, b) => parseInt(a) - parseInt(b) )) {
          if (clustIdSize[clustId] >= this.state.minClustSize) {
            num++;
            clustNum[clustId]=num;
            // console.log(clustId,clustNum[clustId],clustIdSize[clustId])
          }
        }

        // building concord table
        for (i in clusters["byConcord"][tokenId][key]) {
          const clustId=clusters["byConcord"][tokenId][key][i];

          if (clustIdSize[clustId] >= this.state.minClustSize) {
            const subCorpus=labels["byConcord"][tokenId][i][1];
            const sentIdx=labels["byConcord"][tokenId][i][2];
          
            const concord=this.props.results["concord"][subCorpus][sentIdx];
            //console.log(subCorpus,sentIdx,concord);

            if (concord) {
                concord.clustId=clustId;
                concord.clustNum=clustNum[clustId];
                tableDataByConcord.push(concord);
            } else {
                console.log("Non trouvé ",subCorpus,sentIdx);
            }
          }
        }
      }
 
        
      const tableByConcord= byConcord ? <MaterialTable
        title={t('conc')}
        
        columns={[
            {   
                title: t('ID'), 
                field: 'clustId', 
                width: '5%',
                cellStyle: {
                    textAlign:'center',
                    padding:'0',
                },
                headerStyle:{
                    textAlign:'center',
                    padding:'0'
                },
                defaultSort:'asc'

            }, 
            {   
                title: t('context'), 
                width: '5%',
                render: rowData => <Button onClick={this.openContextWindow} value={rowData.sentId} icon='info-sign'></Button>,
                cellStyle: {
                    textAlign:'center',
                    padding:'0',
                },
                headerStyle:{
                    textAlign:'center',
                    padding:'0'
                }
            },
            {   
              title: t('idSent'), 
              width: '15%',
              field: 'sentId',
              cellStyle: {
                  textAlign:'center',
                  padding:'0',
              },
              headerStyle:{
                  textAlign:'center',
                  padding:'0'
              }
            },
            {   
                title: t('leftContext'), 
                field: 'left',
                width: '30%',
                render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(specialSlice(rowData.left,'l',span))} /> ,
                cellStyle: {
                    textAlign:'right',
                    padding:'0',                    
                },
                headerStyle:{
                    textAlign:'center'
                }
            },
            
            {   
                title: t('node'), 
                field: 'node', 
                render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(rowData.node)} /> ,
                cellStyle:{
                    textAlign:'center',
                    padding:'0',                          
                }, 
                headerStyle:{
                    textAlign:'center'
                }
            },
    
            {   
                title: t('rightContext'), 
                field: 'right', 
                width: '30%',
                render: rowData => <div dangerouslySetInnerHTML={prepDangerouslySetInnerHTMLString(specialSlice(rowData.right,'r',span))} /> ,
                cellStyle : {
                    textAlign:'left',
                    padding:'0',
                },
                headerStyle:{
                    textAlign:'center'
                }
            },
          ]}

          data={ tableDataByConcord }
          //onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          components={{
                Pagination: props => (
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={[10, 25, 50, 100, tableDataByConcord.length ]}
                  />
                ),
            }}

          options={{
              selection:true,
              filtering:true,
              search: true,
              sorting: true,
              exportButton: true,
              exportFileName: 'clusters_by_concord',
              padding: 'dense',
              pageSize:100,
              //tableLayout: 'fixed',
              //exportAlldata: true,
              rowStyle: (rowData) => ({
                  backgroundColor: ( rowData.clustNum % 2 === 0) ? '#EEE' : '#FFF',
                  height:'40px',
                  maxHeight:'40px'
              })
          }}
      />:"";


      // By pivot
      const byPivot=clusters["byPivot"][tokenId] && clusters["byPivot"][tokenId][key];
      if (byPivot) {
        const id2pivots={};
        for (i in clusters["byPivot"][tokenId][key]) {
          clustId=clusters["byPivot"][tokenId][key][i];
          if (!id2pivots[clustId]) {
            id2pivots[clustId]=[];
          }
          id2pivots[clustId].push(labels["byPivot"][tokenId][i][0]);
        }
        //console.log(id2pivots);
        for (clustId of Object.keys(id2pivots)) {
          tableDataByPivot.push({ "clustId":clustId, "pivots": id2pivots[clustId].join(", ")});
        }
      }
 
        
      const tableByPivot=byPivot ? <MaterialTable
          title={t('pivots')}
          
          columns={[
              {   
                  title: t('ID'), 
                  field: 'clustId', 
                  width: '5%',
                  cellStyle: {
                      textAlign:'center',
                      verticalAlign:'top',
                      padding:'0',
                  },
                  headerStyle:{
                      textAlign:'center',
                      verticalAlign:'top',
                      padding:'0'
                  },
                  defaultSort:'asc'
              }, 
              {   
                  title: t('pivot'), 
                  width: '95%',
                  field: 'pivots',
                  cellStyle: {
                      textAlign:'center',
                      verticalAlign:'top',
                      padding:'0',
                  },
                  headerStyle:{
                      textAlign:'center',
                      verticalAlign:'top',
                      padding:'0'
                  }
              }
          ]}

          data={ tableDataByPivot }
          
          components={{
                Pagination: props => (
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={[10, 25, 50, 100, tableDataByPivot.length ]}
                  />
                ),
            }}

          options={{
              selection:true,
              filtering:true,
              search: true,
              //sorting: true,
              exportButton: true,
              exportFileName: 'clusters_by_pivot',
              padding: 'dense',
              pageSize:100,
              //tableLayout: 'fixed',
              //exportAlldata: true,
          
          }}
      />:"";

 
      
      const tabAbstract=
              <div className="margin-top-2-rem" >
                <FormGroup label={t('selectTokenForEmbedding')} labelFor='selectTokenForEmbedding' inline={true}>
                  <HTMLSelect id='selectTokenId' name='selectTokenId' onChange={this.onTokenIdChange} value={this.state.tokenId}>
      
                    {
                        Object.keys(labels["byConcord"]).map( id => <option key={id} value={id}>token {id}</option>)
                    }
                
                  </HTMLSelect>
                </FormGroup>

                <H4>{t('synset')}</H4>
                <p><strong>{t('synsetExplanation')}</strong></p>
                {clusters["byPivot"][tokenId]['hypernyms'].map( synset => <p>{synset}</p> )} 

                <H4>{t('classes')}</H4>
                <p><strong>{t('classesExplanation')}</strong></p>
                <p>{t('cosThreshold')} : {clusters["cosThreshold"]}</p><br/>
                {clusters["byPivot"][tokenId]['best'].map( cls => <p>{cls[0].join(", ")+": "+cls[1].toString()}</p> )}  

              </div>;

      const tabDetail=
              <div className="margin-top-2-rem" >
                <FormGroup label={t('selectTokenForEmbedding')} labelFor='selectTokenForEmbedding' inline={true}>
                  <HTMLSelect id='selectTokenId' name='selectTokenId' onChange={this.onTokenIdChange} value={this.state.tokenId}>
      
                    {
                        Object.keys(labels["byConcord"]).map( id => <option key={id} value={id}>token {id}</option>)
                    }
                
                  </HTMLSelect>
                </FormGroup>

                <p>{t('selectTheMinCosSimilarity')}</p>
                <Slider
                    min={0}
                    max={95}
                    labelValues={[0,40,45,50,60,70,75,80,85,90,95]}
                    onChange={(value) => this.setState({ nbClust:0, minCos: value })}
                    value={this.state.minCos}
                    vertical={false}
                />

                <p>{t('otherwise_selectTheDesiredNumberOfClusters')}</p>
                <Slider
                    min={0}
                    max={30}
                    labelValues={[0,2,3,4,5,7,10,15,20,30]}
                    onChange={(value) => this.setState({ minCos:0, nbClust: value })}
                    value={this.state.nbClust}
                    vertical={false}
                />

                <p>{t('minClustSize')}</p>
                <InputGroup 
                  defaultValue={1}
                  onChange={(e) => this.setState({ minClustSize : parseInt(e.target.value)})}
                  width={200}
                />
                
                <Tabs>
                  <Tab key={"byPivot"} id={"byPivot"} title={t("byPivot")} panel={tableByPivot}></Tab> 
                  <Tab key={"byConcord"} id={"byConcord"} title={t("byConcord")} panel={tableByConcord}></Tab>
                </Tabs>   

              </div>

    
      return (
        <>
          <Tabs>
            <Tab key={"abstract"} id={"abstract"} title={t("abstract")} panel={tabAbstract} />
            <Tab key={"detail"} id={"detail"} title={t("detail")} panel={tabDetail} />

          </Tabs>          
        </>
      );
  }
}

ClusterMlm.propTypes = {
  results: PropTypes.object,
  sentId2Concord : PropTypes.object
};

export default withTranslation()(ClusterMlm);
